/* eslint-disable */
<template>
    <main>
        <div class="bootbox modal fade in show" tabindex="-1" role="dialog" style="display: block;">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-body">
                        <button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="closePopup">×</button>
                        <div class="bootbox-body" v-if="!isShow">
                            <div class="row form-group mb-lg">
                                <div class="col-md-12">
                                    <label class="col-md-4">身分證字號:</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="idno" class="form-control"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-offset-4 col-md-4">
                                    <div class=" col-md-offset-3 col-md-6">
                                        <a class="btn btn-danger btn-block" @click="searchBillingInvoice">查詢</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bootbox-body body-by-A4 " id="billingInvoicePrint" ref="billingInvoicePrint" v-if="isShow">
                            <div class="invoice-title">
                                <div class="text-center" style="width:100%;">
                                    <h3> 亞東學校財團法人亞東科技大學{{dormitoryApply.dormitoryType == 'V' ? '寒假':(dormitoryApply.dormitoryType == 'V' ? '特殊原因':`${dormitoryApply.smtr.substring(0,3)}年第${dormitoryApply.smtr.substring(3)}學期`)}}住宿費繳費通知單 </h3>
                                </div>
                                <p></p>
                                <div class="invoice-title-value">
                                    <div class="text-center desc-title">
                                        <p>【注意事項】</p>
                                    </div>
                                    <div class="desc-content">
                                        <p>1.繳費期間: {{customFormatter(dormitoryApply.paymentEndDate)}}，逾期未繳費視同放棄住宿。</p>
                                        <p v-if="dormitoryApply.dormitoryType == 'N'">2.本住宿費收取，一學期收取一次。</p>
                                        <p v-if="dormitoryApply.dormitoryType == 'N'">
                                            3.如身分別為低收入戶(持有政府證明文件)、外離島學生(設籍並居住金、馬、澎湖等地)為免收住宿費，
                                            尚須 繳納保證金1,000元(可退費)，特殊身分學生前揭兩項金額不在申 請減免範圍。
                                        </p>
                                      </div>
                                </div>
                                <p></p>
                                <div class="invoice-title-value">
                                    <div class="text-center desc-title">
                                        <p>【繳費方式】</p>
                                    </div>
                                    <div class="desc-content">
                                        <p>1.至遠東國際商業銀行全省各分行繳費(免手續費)。</p>
                                        <p>2.全省各行庫跨行匯款、自動櫃員機(ATM)、WebATM或網路銀行繳費(手續費自付)。</p>
                                        <p>3.至全省7-11、全家、萊爾富及OK四家便利超商繳費(手續費自付)。</p>
                                        <p>4.學生收據請妥善保存，以備爾後查核及申報所得稅使用。</p>
                                    </div>
                                </div>
                            </div>
                            <p></p>
                            <table class="invoice-content">
                                <tr>
                                    <td class="billing-left-div">
                                        <p></p>
                                        <div>
                                            <div class="invoice-content-title">第一聯</div>
                                            <div class="text-center invoice-content-value">
                                                <table class="table table-bordered" style="width:99%;">
                                                    <tbody>
                                                        <tr>
                                                            <td colspan="3"> 亞東學校財團法人亞東科技大學{{dormitoryApply.dormitoryType == 'V' ? '寒假住宿':(dormitoryApply.dormitoryType == 'V' ? '特殊原因住宿':`${dormitoryApply.smtr.substring(0,3)}年第${dormitoryApply.smtr.substring(3)}學期`)}} </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="width:30%;"> 繳費項目 </td>
                                                            <td style="width:30%;"> 金額 </td>
                                                            <td class="text-left" style="width:39%;" rowspan="2">
                                                                <p></p>
                                                                <p>系所: &emsp; {{stuBase.deptCodeStr}}</p>
                                                                <p></p>
                                                                <p>班別: &emsp; {{stuBase.drade}}年{{stuBase.dradeClass}}班</p>
                                                                <p>姓名: &emsp; {{stuBase.name}}</p>
                                                                <p>學號: &emsp; {{stuBase.account}}</p>
                                                                <p class="stu-barcode"><barcode v-if="account != ''" v-bind:value="stuBase.account" v-bind:displayValue="false" width="1" height="20" format="CODE39" elementTag="img"></barcode></p>
                                                            </td>
                                                        </tr>
                                                        <tr class="text-left">
                                                            <td rowspan="3"> 住宿費<br/> {{dormitoryApply.ensureAmt > 0 ? `保證金` : ""}} </td>
                                                            <td rowspan="3"> {{dormitoryApply.roomAmt}}<br/> {{dormitoryApply.ensureAmt > 0 ? dormitoryApply.ensureAmt : ""}} </td>
                                                        </tr>
                                                        <tr>
                                                            <td> 收訖章 </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="height:1.5cm;"></td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="3">
                                                                <span style="width:45%; display:inline-block;">應繳合計:</span>
                                                                <span style="width:45%; display:inline-block;">{{dormitoryApply.roomAmt+dormitoryApply.ensureAmt}}</span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <p>【就學貸款可貸金額:0】</p>
                                                <p></p>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="billing-right-div">
                                        <p></p>
                                        <div>
                                            <div class="invoice-content-title">第二聯</div>
                                            <div class="text-center invoice-content-value" style="">
                                                <table class="table table-bordered" style="width:99%;">
                                                    <tbody>
                                                        <tr>
                                                            <td colspan="3"> 亞東學校財團法人亞東科技大學{{dormitoryApply.dormitoryType == 'V' ? '寒假住宿':(dormitoryApply.dormitoryType == 'V' ? '特殊原因住宿':`${dormitoryApply.smtr.substring(0,3)}年第${dormitoryApply.smtr.substring(3)}學期`)}} </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="width:30%;"> 繳費項目 </td>
                                                            <td style="width:30%;"> 金額 </td>
                                                            <td class="text-left" style="width:39%;" rowspan="2">
                                                                <p></p>
                                                                <p>系所: &emsp; {{stuBase.deptCodeStr}}</p>
                                                                <p></p>
                                                                <p>班別: &emsp; {{stuBase.drade}}年{{stuBase.dradeClass}}班</p>
                                                                <p>姓名: &emsp; {{stuBase.name}}</p>
                                                                <p>學號: &emsp; {{stuBase.account}}</p>
                                                                <p class="stu-barcode"><barcode v-if="stuBase.account != ''" v-bind:value="stuBase.account" v-bind:displayValue="false" width="1" height="20" format="CODE39" elementTag="img"></barcode></p>
                                                            </td>
                                                        </tr>
                                                        <tr class="text-left">
                                                            <td rowspan="3"> 住宿費<br/> {{dormitoryApply.ensureAmt > 0 ? `保證金` : ""}} </td>
                                                            <td rowspan="3"> {{dormitoryApply.roomAmt}}<br/> {{dormitoryApply.ensureAmt > 0 ? dormitoryApply.ensureAmt : ""}} </td>
                                                        </tr>
                                                        <tr>
                                                            <td> 收訖章 </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="height:1.5cm;"></td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="3">
                                                                <span style="width:45%; display:inline-block;">應繳合計:</span>
                                                                <span style="width:45%; display:inline-block;">{{dormitoryApply.roomAmt+dormitoryApply.ensureAmt}}</span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <p>【就學貸款可貸金額:0】</p>
                                                <p></p>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <div class="invoice-footer">
                                <p></p>
                                <div style="width:100%;">
                                    <p>【ATM/網路銀行繳費】輸入遠東銀行代碼(805)→輸入繳費帳號({{dormitoryApply.bankBarcode_1}})→輸入繳費金額</p>
                                    <div>
                                        <div class="invoice-footer-title">第三聯</div>
                                        <div class="invoice-footer-value">
                                            <table class="table table-bordered" style="width:100%; height:100%;">
                                                <tbody>
                                                    <tr>
                                                        <td colspan="4"> (貸) 遠東商銀板橋南雅分行(805-0090)</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="width:15%;">學校名稱</td>
                                                        <td style="width:35%;">亞東學校財團法人亞東科技大學</td>
                                                        <td style="width:15%;" class="text-center">收訖章</td>
                                                        <td style="width:35%; " class="text-center">便利商店繳費專區</td>
                                                    </tr>
                                                    <tr>
                                                        <td>學生姓名</td>
                                                        <td>
                                                            <span style="width:50%; display:inline-block;">{{stuBase.name}}</span>
                                                            <span style="width:50%; display:inline-block;">
                                                                (請務必填寫姓名)
                                                            </span>
                                                        </td>
                                                        <td rowspan="3"></td>
                                                        <td rowspan="4">
                                                            <p class="text-center">代收超商:7-1 1 、全家、萊爾富及OK<br/>(單筆最高代收金額八萬元、手續費自付)</p>
                                                            <p class="text-left barcode-1">
                                                                <small>條碼1 &emsp; *{{dormitoryApply.storeBarcode1}}*</small><br>
                                                                <barcode v-if="dormitoryApply.storeBarcode_1 != ''" v-bind:value="dormitoryApply.storeBarcode1" v-bind:displayValue="false" width="1" height="20" format="CODE39" elementTag="img"></barcode>
                                                            </p>
                                                            <p class="text-left barcode-2">
                                                                <small>條碼2 &emsp; *{{dormitoryApply.storeBarcode2}}*</small><br>
                                                                <barcode v-if="dormitoryApply.storeBarcode_2 != ''" v-bind:value="dormitoryApply.storeBarcode2" v-bind:displayValue="false" width="1" height="20" format="CODE39" elementTag="img"></barcode>
                                                            </p>
                                                            <p class="text-left barcode-3">
                                                                <small>條碼3 &emsp; *{{dormitoryApply.storeBarcode3}}*</small><br>
                                                                <barcode v-if="dormitoryApply.storeBarcode_3 != ''" v-bind:value="dormitoryApply.storeBarcode3" v-bind:displayValue="false" width="1" height="20" format="CODE39" elementTag="img"></barcode>
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>繳費帳號</td>
                                                        <td>{{dormitoryApply.bankBarcode_1}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>繳費金額</td>
                                                        <td>{{dormitoryApply.roomAmt+dormitoryApply.ensureAmt}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3">
                                                            <p class="text-left">銀行/郵局代收專區</p>
                                                            <p class="text-left">&emsp;</p>
                                                            <p class="text-left">&emsp;</p>
                                                            <p class="text-left">
                                                                <span style="width:10%; display:inline-block;"></span>
                                                                <span style="width:40%; display:inline-block;" class="bank-barcode-1">
                                                                    <small>繳費帳號: {{dormitoryApply.bankBarcode1}}</small><br />
                                                                    <barcode v-if="dormitoryApply.bankBarcode1 != ''" v-bind:value="dormitoryApply.bankBarcode1" v-bind:displayValue="false" width="1" height="20" format="CODE39" elementTag="img"></barcode>
                                                                </span>

                                                                <span style="width:40%; display:inline-block;" class="bank-barcode-2">
                                                                    <small>繳費金額: {{dormitoryApply.roomAmt+dormitoryApply.ensureAmt}}</small><br />
                                                                    <barcode v-if="dormitoryApply.bankBarcode2 != ''" v-bind:value="dormitoryApply.roomAmt+dormitoryApply.ensureAmt" v-bind:displayValue="false" width="1" height="20" format="CODE39" elementTag="img"></barcode>
                                                                </span>
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center" v-if="isShow">
                            <button @click="printInvoice" class="no-print">列印</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import { Printd } from 'printd'
import VueBarcode from 'vue-barcode';
export default {
	data(){
		return{
            idno:"",
			stuBase:{},
			dormitoryApply:{},
            isShow:false,
		}
	},
	created(){
        this.isShow = false;
	},
	components:{
		'barcode': VueBarcode
	},
	methods:{
        searchBillingInvoice(){
            if(!this.idno){
                bootbox.alert("請填寫身分證號");
                return false;
            }
            this.popupInit();
        },
		popupInit(){
			const Api = async () => {
                const api = `/api/Room/billingInvoice/${window.btoa(this.idno.replace(/\s+/g, ''))}`;
                return await this.$axios.post(api);
            }
            Promise.resolve(Api()).then(resp => {
                if(resp.data.status == "00"){
                    this.stuBase = resp.data.data.stuBase;
                    this.dormitoryApply = resp.data.data.dormitoryApply;
                    this.isShow = true;
                }
                if(resp.data.status == "error") {
                  bootbox.alert(resp.data.msg);
                }
            });
		},
		closePopup() {
			this.$parent.showStayBillingControl(false);
		},
		printInvoice(){
			const d = new Printd();
			d.print(document.getElementById('billingInvoicePrint'),[
				`.text-center {text-align: center;}
				.text-left{text-align: left;}
				.body-by-A4 .invoice-title-value { width: 100%; }
				.body-by-A4 .invoice-title-value p { font-size: 13px; }
				.body-by-A4 table tr td h5 { margin: 2px; }
				.body-by-A4 p { margin: 0 0 5px !important; }
				.table{ width: 98% !important; margin-bottom: 5px !important; }
				.table-bordered{border: 1px solid #ddd;}
				tbody{ display: table-row-group; border: inherit; font-size:12px;}
				.table-bordered>tbody>tr>td{ padding: 0; line-height: 1.42857143; vertical-align: top; border: 1px solid #ddd; }
				.table-bordered>tbody>tr>td>p{ font-size:10px; }
				h3{margin:0 !important;}
				.invoice-title {height:auto;}
				.invoice-content {height:7cm; width:100%;}
				.invoice-content p{ font-size:12px; }
				.invoice-content-title{width:5%; display:inline-block; float:left;}
				.invoice-content-value{width:95%; display:inline-block; float:left;}

				.invoice-footer {height:7cm; width:100%;}
				.invoice-footer p{ font-size:12px; }
				.invoice-footer-title{width:2%; display:inline-block; float:left;}
				.invoice-footer-value{width:98%; display:inline-block; float:left;}

				.billing-left-div { border-top-style: dashed; border-bottom-style: dashed; border-right-style: dashed; border-width: 1px; }
				.billing-right-div { border-top-style: dashed; border-bottom-style: dashed; border-width: 1px; }
				.desc-title{ width:15%; display:inline-block; vertical-align: top; }
				.desc-content{ width:85%; display:inline-block; vertical-align: top; }
				.barcode-1 img{width:65%;}
				.barcode-2 img{width:95%;}
				.barcode-3 img{width:96%;}
				.bank-barcode-1 img{width:100%;}
				.bank-barcode-2 img{width:36%; height: 26px;}
				.stu-barcode img{width:100%;}
				`
			]);
		}
	}
}
</script>
<style scoped>
@media (min-width: 800px){
	.modal-body{
		overflow-x:hidden;
	}
}
.modal-body{
	overflow-x:auto;
}
.body-by-A4{
	overflow-y:auto;
	height: 120mm;
	width: 210mm;
	margin:1cm;
}
.body-by-A4 .invoice-title-value { width: 100%; }
.body-by-A4 .invoice-title-value p { font-size: 13px; }
.body-by-A4 table tr td h5 { margin: 2px; }
.body-by-A4 p { margin: 0 0 5px !important; }
.invoice-title {height:auto;}
.invoice-content {height:9cm; width: 100%;}
.invoice-content-title{width:5%; display:inline-block; float:left;}
.invoice-content-value{width:95%; display:inline-block; float:left;}

.invoice-footer {height:8cm; width:100%;}
.invoice-footer-title{width:3%; display:inline-block; float:left;}
.invoice-footer-value{width:95%; display:inline-block; float:left;}

.billing-left-div {
	border-top-style: dashed;
	border-bottom-style: dashed;
	border-right-style: dashed;
	border-width: 1px;
}
.billing-right-div {
	border-top-style: dashed;
	border-bottom-style: dashed;
	border-width: 1px;
}
.desc-title{
	width:15%;
	display:inline-block;
	vertical-align: top;
}
.desc-content{
	width:85%;
	display:inline-block;
	vertical-align: top;
}
.barcode-1 img{
	width:65%;
	height: 26px;
}
.barcode-2 img{
	width:95%;
	height: 26px;
}
.barcode-3 img{
	width:96%;
	height: 26px;
}
.bank-barcode-1 img{
	width:100%;
	height: 26px;
}
.bank-barcode-2 img{
	width:36%;
	height: 26px;
}
.stu-barcode img{
	width:100%;
	height: 26px;
}
@media print {
    .body-by-A4 {
        width: 210mm;
        height: 267mm;
    }
	.no-print{
		display: none;
	}
    @page {
        size: A4;
        margin:0 !important;
		padding: 0 !important;
    }
}
</style>
